export const useColumn = () => {
  let columns = [
    {
      title: '编号',
      dataIndex: 'code',
      scopedSlots: { customRender: 'code' },
      width: 170,
    },
    {
      title: '项目名称',
      dataIndex: 'project',
      scopedSlots: { customRender: 'project' },
      ellipsis: true,
    },
    {
      title: '开标时间',
      dataIndex: 'kbdate',
      width: 150,
      sorter: true,
    },
  ];
  columns.push({
    title: '申请人',
    dataIndex: 'bidder',
    scopedSlots: { customRender: 'bidder' },
    ellipsis: true,
  });
  columns.push(
    ...[
      {
        title: '担保金额',
        dataIndex: 'money',
        width: 100,
        slots: { customRender: 'money' },
        customRender: (text) => {
          return text + '元';
        },
        sorter: true,
      },
      {
        title: '担保费',
        dataIndex: 'poundage',
        slots: { customRender: 'poundage' },
        customRender: (text) => {
          return text + '元';
        },
        width: 80,
        sorter: true,
      },
      {
        title: '出函时间',
        dataIndex: 'sign_time',
        sorter: true,
        width: 150,
      },
      {
        title: '支付时间',
        dataIndex: 'pay_time',
        sorter: true,
        width: 150,
      },
      {
        title: '保函状态',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' },
        width: 75,
      },
    ],
  );
  return columns;
};
